module.exports = __webpack_public_path__ + "static/media/YM49_0.91688ba5.jpg";